import { render, staticRenderFns } from "./SDataTable.vue?vue&type=template&id=70aa0047&scoped=true&"
import script from "./SDataTable.vue?vue&type=script&lang=js&"
export * from "./SDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa0047",
  null
  
)

export default component.exports